import { action } from "typesafe-actions";
import {
  IAccountingAccountPayableReport,
  IAccountReceivableDetailed,
  IAccountReceivableReport,
  IAccoutingTaxStatement,
  IAgedInsurerPayables,
  IInsuranceRemittance,
  ISalesCommissionDetailed,
  ISalesCommissionDetailedBreakdown,
  ISalesCommissionSummary,
} from "./AccountingReports.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import { getFilenameFromContentDisposition } from "../../../helpers";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import moment from "moment";
import { getFileExtensionFromUrl } from "../../../helpers";

export function generateAdvanceFilterQuery(
  data: any,
  summaryView?: boolean,
  overrideProducerField: "producer_code" | "producer_id" = "producer_id"
) {
  const filters = [];

  for (const [key, value] of Object.entries(data)) {
    if (value !== "" && value !== null) {
      let filterObj = {
        column: [key],
        operator: "EQUAL",
        value: value,
        logicalOperator: "AND",
      };
      if (key === "transaction_date") {
        filterObj = {
          column: [key],
          operator: "CONTAINS",
          value: value + "-",
          logicalOperator: "AND",
        };
      }
      if (key === "transaction_effective_date") {
        filterObj = {
          column: [key],
          operator: "CONTAINS",
          value: value + "",
          logicalOperator: "AND",
        };
      }

      if (key === "transaction_date_month") {
        filterObj = {
          column: ["transaction_date"],
          operator: "CONTAINS",
          value:
            (data["transaction_date"] || moment().year()) + "-" + value + "-",
          logicalOperator: "AND",
        };
      }

      if (key === "user_fact_id" && summaryView) {
        const filterObj = {
          column: ["producer_one_id", "producer_two_id", "producer_three_id"],
          operator: "EQUAL",
          value: value,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        filters.push(`advanceFilter=${encodedFilter}`);
      } else if (key === "user_code") {
        const filterObj = {
          column: [overrideProducerField],
          operator: "EQUAL",
          value: value,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        filters.push(`advanceFilter=${encodedFilter}`);
      } else {
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        filters.push(`advanceFilter=${encodedFilter}`);
      }
    }
  }

  return filters.join("&");
}

export const FETCH_SALES_COMMISSION_SUMMARY_LIST_PROGRESS =
  "FETCH_SALES_COMMISSION_SUMMARY_LIST_PROGRESS";
export const FETCH_SALES_COMMISSION_SUMMARY_LIST_SUCCESS =
  "FETCH_SALES_COMMISSION_SUMMARY_LIST_SUCCESS";
export const FETCH_SALES_COMMISSION_SUMMARY_LIST_FAILURE =
  "FETCH_SALES_COMMISSION_SUMMARY_LIST_FAILURE";

export const fetchSalesCommissionSalesSummaryListProgress = () =>
  action(FETCH_SALES_COMMISSION_SUMMARY_LIST_PROGRESS);
export const fetchSalesCommissionSalesSummaryListSuccess = (
  list: ISalesCommissionSummary[]
) => action(FETCH_SALES_COMMISSION_SUMMARY_LIST_SUCCESS, { list });
export const fetchSalesCommissionSalesSummaryListFailure = () =>
  action(FETCH_SALES_COMMISSION_SUMMARY_LIST_FAILURE);

export const fetchSalesCommissionSalesSummaryListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    searchState: {
      [key: string]: any;
    }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchSalesCommissionSalesSummaryListProgress());

      const { sub_type, ...finalSearchState } = searchState;

      const query = generateAdvanceFilterQuery(
        finalSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/calculate-bills-of-agency-or-direct-bill?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&`;

      if (query) {
        finalUrl += query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      dispatch(fetchSalesCommissionSalesSummaryListSuccess(data));
    } catch (err: any) {
      dispatch(fetchSalesCommissionSalesSummaryListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchSalesCommissionSalesSummaryForExportAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    searchState: {
      [key: string]: any;
    },
    onCallback: (data: ISalesCommissionSummary[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      const query = generateAdvanceFilterQuery(
        searchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/calculate-bills-of-agency-or-direct-bill?pageNo=1&itemPerPage=500000`;
      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      onCallback(data);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/*---------*/
export const FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_PROGRESS =
  "FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_PROGRESS";
export const FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_SUCCESS =
  "FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_SUCCESS";
export const FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_FAILURE =
  "FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_FAILURE";

export const fetchSalesCommissionSalesSummaryByTypeListProgress = () =>
  action(FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_PROGRESS);
export const fetchSalesCommissionSalesSummaryByTypeListSuccess = (
  list: ISalesCommissionSummary[]
) => action(FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_SUCCESS, { list });
export const fetchSalesCommissionSalesSummaryByTypeListFailure = () =>
  action(FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_FAILURE);

export const fetchSalesCommissionSalesSummaryByTypeListAsync =
  (
    type: string,
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    searchState: {
      [key: string]: any;
    }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchSalesCommissionSalesSummaryByTypeListProgress());

      const {
        sub_type,
        transaction_from_date,
        transaction_to_date,
        ...finalSearchState
      } = searchState;

      const query = generateAdvanceFilterQuery(
        finalSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-sales-and-commission-producer-branch-insurer?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&report_type=SC&sub_type=${type}&`;
      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }
      if (query) {
        finalUrl += query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      dispatch(fetchSalesCommissionSalesSummaryByTypeListSuccess(data));
    } catch (err: any) {
      dispatch(fetchSalesCommissionSalesSummaryByTypeListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchSalesCommissionSalesSummaryForProducerExportAsync =
  (
    type: string,
    searchState: {
      [key: string]: any;
    },
    onCallback: (data: ISalesCommissionSummary[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { transaction_from_date, transaction_to_date, ...restSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(
        restSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-sales-and-commission-producer-branch-insurer?pageNo=1&itemPerPage=50000&is_downloading=true&report_type=SC&sub_type=${type}`;
      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      onCallback(data);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/*---------*/
export const FETCH_SALES_COMMISSION_DETAILED_LIST_PROGRESS =
  "FETCH_SALES_COMMISSION_DETAILED_LIST_PROGRESS";
export const FETCH_SALES_COMMISSION_DETAILED_LIST_SUCCESS =
  "FETCH_SALES_COMMISSION_DETAILED_LIST_SUCCESS";
export const FETCH_SALES_COMMISSION_DETAILED_LIST_FAILURE =
  "FETCH_SALES_COMMISSION_DETAILED_LIST_FAILURE";

export const fetchSalesCommissionSalesDetailedListProgress = () =>
  action(FETCH_SALES_COMMISSION_DETAILED_LIST_PROGRESS);
export const fetchSalesCommissionSalesDetailedListSuccess = (
  list: ISalesCommissionDetailed[]
) => action(FETCH_SALES_COMMISSION_DETAILED_LIST_SUCCESS, { list });
export const fetchSalesCommissionSalesDetailedListFailure = () =>
  action(FETCH_SALES_COMMISSION_DETAILED_LIST_FAILURE);

export const fetchSalesCommissionSalesDetailedListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    subType: string,
    fromDate: string,
    toDate: string,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchSalesCommissionSalesDetailedListProgress());
      const {
        sub_type,
        transaction_from_date,
        transaction_to_date,
        ...finalSearchState
      } = searchState;
      const query = generateAdvanceFilterQuery(
        finalSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-sales-and-commission?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&`;

      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_effective_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_effective_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `advanceFilter=${encodedFilter}&`;
      }

      if (query) {
        finalUrl += query;
      }
      // if (fromDate) {
      //   const filterObj = {
      //     column: ["transaction_date"],
      //     operator: "GREATER_THAN_EQUAL",
      //     value: fromDate,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }

      // if (toDate) {
      //   const filterObj = {
      //     column: ["transaction_date"],
      //     operator: "LESSER_THAN_EQUAL",
      //     value: toDate,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }

      finalUrl =
        finalUrl + `&report_type=SC&sub_type=${subType}&order_by=invoice_date`;

      const res = await api.get(finalUrl);
      const data = res.data.data;
      dispatch(fetchSalesCommissionSalesDetailedListSuccess(data));
    } catch (err: any) {
      dispatch(fetchSalesCommissionSalesDetailedListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };
export const FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_PROGRESS =
  "FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_PROGRESS";
export const FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_SUCCESS =
  "FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_SUCCESS";
export const FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_FAILURE =
  "FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_FAILURE";

export const fetchSalesCommissionSalesDetailedBreakdownListProgress = () =>
  action(FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_PROGRESS);
export const fetchSalesCommissionSalesDetailedBreakdownListSuccess = (
  list: ISalesCommissionDetailedBreakdown[]
) => action(FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_SUCCESS, { list });
export const fetchSalesCommissionSalesDetailedBreakdownListFailure = () =>
  action(FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_FAILURE);

export const fetchSalesCommissionSalesDetailedBreakdownListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    subType: string,
    fromDate: string,
    toDate: string,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchSalesCommissionSalesDetailedBreakdownListProgress());
      const {
        sub_type,
        transaction_from_date,
        transaction_to_date,
        ...finalSearchState
      } = searchState;
      const query = generateAdvanceFilterQuery(
        finalSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-sales-and-commission-detailed-breakdown?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&`;

      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `advanceFilter=${encodedFilter}&`;
      }

      if (query) {
        finalUrl += query;
      }
      // if (fromDate) {
      //   const filterObj = {
      //     column: ["transaction_date"],
      //     operator: "GREATER_THAN_EQUAL",
      //     value: fromDate,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }

      // if (toDate) {
      //   const filterObj = {
      //     column: ["transaction_date"],
      //     operator: "LESSER_THAN_EQUAL",
      //     value: toDate,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}`;
      // }

      finalUrl =
        finalUrl + `&report_type=SC&sub_type=${subType}&order_by=invoice_date`;

      const res = await api.get(finalUrl);
      const data = res.data.data;
      console.log("data", data);
      dispatch(fetchSalesCommissionSalesDetailedBreakdownListSuccess(data));
    } catch (err: any) {
      dispatch(fetchSalesCommissionSalesDetailedBreakdownListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };
// detailed
export const fetchSalesCommissionSalesDetailedForExportAsync =
  (
    subType: string,
    fromDate: string,
    toDate: string,
    searchState: { [key: string]: any },
    onCallback: (data: ISalesCommissionDetailed[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { transaction_from_date, transaction_to_date, ...restSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(
        restSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-sales-and-commission?pageNo=1&itemPerPage=50000&is_downloading=true&report_type=SC&sub_type=${subType}`;
      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      onCallback(data);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

// detailed - PDF download
export const fetchSalesCommissionSalesDetailedPdfForExportAsync =
  (
    subType: string,
    fromDate: string,
    toDate: string,
    searchState: { [key: string]: any },
    onCallback: () => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { transaction_from_date, transaction_to_date, ...restSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(
        restSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-sales-and-commission-pdf?pageNo=1&itemPerPage=50000&report_type=SC&sub_type=${subType}`;
      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl, {
        responseType: "arraybuffer",
      });

      const pdfBlob = new Blob([res.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = getFilenameFromContentDisposition(
        res,
        "Sales-Commission-Detailed.pdf"
      );
      link.click();

      URL.revokeObjectURL(pdfUrl);
      onCallback();
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err?.response?.data?.message || "Failed to download PDF",
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

// breakdown
export const fetchSalesCommissionSalesDetailedBreakdownForExportAsync =
  (
    subType: string,
    fromDate: string,
    toDate: string,
    searchState: { [key: string]: any },
    onCallback: (data: ISalesCommissionDetailedBreakdown[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { transaction_from_date, transaction_to_date, ...restSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(
        restSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-sales-and-commission-detailed-breakdown?pageNo=1&itemPerPage=50000&report_type=SC&sub_type=${subType}&order_by=invoice_date`;
      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_effective_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_effective_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      onCallback(data);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/**-------- */

/*---------*/
export const FETCH_RECEIVABLE_REPORT_LIST_PROGRESS =
  "FETCH_RECEIVABLE_REPORT_LIST_PROGRESS";
export const FETCH_RECEIVABLE_REPORT_LIST_SUCCESS =
  "FETCH_RECEIVABLE_REPORT_LIST_SUCCESS";
export const FETCH_RECEIVABLE_REPORT_LIST_FAILURE =
  "FETCH_RECEIVABLE_REPORT_LIST_FAILURE";

export const fetchReceivableReportListProgress = () =>
  action(FETCH_RECEIVABLE_REPORT_LIST_PROGRESS);
export const fetchReceivableReportListSuccess = (
  list: IAccountReceivableReport[]
) => action(FETCH_RECEIVABLE_REPORT_LIST_SUCCESS, { list });
export const fetchReceivableReportListFailure = () =>
  action(FETCH_RECEIVABLE_REPORT_LIST_FAILURE);

export const CHANGE_BALANCE_WAIVER_RUNNING_BALANCE = "CHANGE_BALANCE_WAIVER_RUNNING_BALANCE";

export const changeBalanceWaiverRunningBalance = (index: number, runningBalance: number) =>
  action(CHANGE_BALANCE_WAIVER_RUNNING_BALANCE, { index, runningBalance });

export const fetchReceivableReportListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchReceivableReportListProgress());
      const { transaction_from_date, transaction_to_date, ...restSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(
        restSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-account-receivable-reports?type=SUMMARY&pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}`;
      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      dispatch(fetchReceivableReportListSuccess(data));
    } catch (err: any) {
      dispatch(fetchReceivableReportListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

  export const downloadAccountReceivableReportPDFAsync =
  (
    type: string,
    user_id: string,
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    searchState: { [key: string]: any },
    onCallback: () => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { transaction_from_date, transaction_to_date, ...restSearchState } =
      searchState;
    const query = generateAdvanceFilterQuery(
      restSearchState,
      false,
      "producer_code"
    );
    let finalUrl = `/accounting/get-account-receivable-reports-pdf?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&user_id=${user_id}&type=${type}&is_downloading=true`;

      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }
      const res = await api.get(
        finalUrl,
        {
          responseType: "arraybuffer",
        }
      );

      const pdfBuffer = res.data;

      const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = getFilenameFromContentDisposition(res);
      link.click();

      URL.revokeObjectURL(pdfUrl);
      onCallback();
    } catch (err: any) {
      // dispatch(fetchAutomobileOcep17Failed(ERROR_MESSAGES.SERVER_ERROR));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const fetchReceivableReportForExportAsync =
  (
    searchState: { [key: string]: any },
    onCallback: (data: IAccountReceivableReport[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { transaction_from_date, transaction_to_date, ...restSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(
        restSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-account-receivable-reports?type=SUMMARY&is_downloading=true`;
      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}&`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      onCallback(data);
    } catch (err: any) {
      onCallback([]);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/**-------- */

/*---------*/
export const FETCH_TAX_REPORT_LIST_PROGRESS = "FETCH_TAX_REPORT_LIST_PROGRESS";
export const FETCH_TAX_REPORT_LIST_SUCCESS = "FETCH_TAX_REPORT_LIST_SUCCESS";
export const FETCH_TAX_REPORT_LIST_FAILURE = "FETCH_TAX_REPORT_LIST_FAILURE";

export const fetchTaxReportListProgress = () =>
  action(FETCH_TAX_REPORT_LIST_PROGRESS);
export const fetchTaxReportListSuccess = (list: IAccoutingTaxStatement[]) =>
  action(FETCH_TAX_REPORT_LIST_SUCCESS, { list });
export const fetchTaxReportListFailure = () =>
  action(FETCH_TAX_REPORT_LIST_FAILURE);

export const fetchTaxReportListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchTaxReportListProgress());
      const {
        tarnsaction_from_date,
        tarnsaction_to_date,
        policy_type,
        ...restSearchState
      } = searchState;
      const query = generateAdvanceFilterQuery(restSearchState);
      let finalUrl = `accounting/get-sales-tax-report?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}`;

      if (tarnsaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: tarnsaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (tarnsaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: tarnsaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (policy_type && policy_type.length > 0) {
        const filterObj = {
          column: ["policy_type"],
          operator: "IN",
          value: policy_type,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      dispatch(fetchTaxReportListSuccess(data));
    } catch (err: any) {
      dispatch(fetchTaxReportListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchTaxReportForExportAsync =
  (
    searchState: { [key: string]: any },
    onCallback: (data: IAccoutingTaxStatement[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { tarnsaction_from_date, tarnsaction_to_date, ...restSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(restSearchState);
      let finalUrl = `accounting/get-sales-tax-report?is_downloading=true`;

      if (tarnsaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: tarnsaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (tarnsaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: tarnsaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      onCallback(data);
    } catch (err: any) {
      onCallback([]);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/**-------- */

/*---------*/
export const FETCH_ACCOUNT_PAYABLE_LIST_PROGRESS =
  "FETCH_ACCOUNT_PAYABLE_LIST_PROGRESS";
export const FETCH_ACCOUNT_PAYABLE_LIST_SUCCESS =
  "FETCH_ACCOUNT_PAYABLE_LIST_SUCCESS";
export const FETCH_ACCOUNT_PAYABLE_LIST_FAILURE =
  "FETCH_ACCOUNT_PAYABLE_LIST_FAILURE";

export const fetchAccountPayableListProgress = () =>
  action(FETCH_ACCOUNT_PAYABLE_LIST_PROGRESS);
export const fetchAccountPayableListSuccess = (
  list: IAccountingAccountPayableReport[]
) => action(FETCH_ACCOUNT_PAYABLE_LIST_SUCCESS, { list });
export const fetchAccountPayableListFailure = () =>
  action(FETCH_ACCOUNT_PAYABLE_LIST_FAILURE);

export const fetchAccountPayableListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountPayableListProgress());
      const { transaction_from_date, transaction_to_date, vendor_type, ...restSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(restSearchState);
      let finalUrl = `/accounting/get-account-payable-reports?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}`;

      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      if (vendor_type !== "-1") {
        const filterObj = {
          column: ["vendor_type"],
          operator: "EQUAL",
          value: vendor_type,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      dispatch(fetchAccountPayableListSuccess(data));
    } catch (err: any) {
      dispatch(fetchAccountPayableListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchAccountPayableListForExportAsync =
  (
    searchState: { [key: string]: any },
    onCallback: (data: IAccountingAccountPayableReport[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { transaction_from_date, transaction_to_date, vendor_type, ...restSearchState } =
        searchState;
      const query = generateAdvanceFilterQuery(restSearchState);
      let finalUrl = `/accounting/get-account-payable-reports?is_downloading=true`;

      if (transaction_from_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "GREATER_THAN_EQUAL",
          value: transaction_from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (transaction_to_date) {
        const filterObj = {
          column: ["transaction_date"],
          operator: "LESSER_THAN_EQUAL",
          value: transaction_to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      if (vendor_type !== "-1") {
        const filterObj = {
          column: ["vendor_type"],
          operator: "EQUAL",
          value: vendor_type,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      onCallback(data);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

/**-------- */

/*---------*/
export const FETCH_RECEIVABLE_DETAILED_REPORT_LIST_PROGRESS =
  "FETCH_RECEIVABLE_DETAILED_REPORT_LIST_PROGRESS";
export const FETCH_RECEIVABLE_DETAILED_REPORT_LIST_SUCCESS =
  "FETCH_RECEIVABLE_DETAILED_REPORT_LIST_SUCCESS";
export const FETCH_RECEIVABLE_DETAILED_REPORT_LIST_FAILURE =
  "FETCH_RECEIVABLE_DETAILED_REPORT_LIST_FAILURE";

export const fetchReceivableDetailedReportListProgress = () =>
  action(FETCH_RECEIVABLE_DETAILED_REPORT_LIST_PROGRESS);
export const fetchReceivableDetailedReportListSuccess = (
  list: IAccountReceivableDetailed[]
) => action(FETCH_RECEIVABLE_DETAILED_REPORT_LIST_SUCCESS, { list });
export const fetchReceivableDetailedReportListFailure = () =>
  action(FETCH_RECEIVABLE_DETAILED_REPORT_LIST_FAILURE);

export const fetchReceivableDetailedReportListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    searchState: { [key: string]: any }
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchReceivableDetailedReportListProgress());

      const { from_date, to_date, ...restSearchState } = searchState;
      const query = generateAdvanceFilterQuery(
        restSearchState,
        false,
        "producer_code"
      );
      let finalUrl = `/accounting/get-account-receivable-reports?type=DETAILED&pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}`;

      if (from_date) {
        const filterObj = {
          column: ["date"],
          operator: "GREATER_THAN_EQUAL",
          value: from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (to_date) {
        const filterObj = {
          column: ["date"],
          operator: "LESSER_THAN_EQUAL",
          value: to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      dispatch(fetchReceivableDetailedReportListSuccess(data));
    } catch (err: any) {
      dispatch(fetchReceivableDetailedReportListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchReceivableDetailedReportForExportAsync =
  (
    searchState: { [key: string]: any },
    onCallback: (data: IAccountReceivableDetailed[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      const { from_date, to_date, ...restSearchState } = searchState;
      const query = generateAdvanceFilterQuery(restSearchState);
      let finalUrl = `/accounting/get-account-receivable-reports?type=DETAILED&is_downloading=true`;

      if (from_date) {
        const filterObj = {
          column: ["date"],
          operator: "GREATER_THAN_EQUAL",
          value: from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (to_date) {
        const filterObj = {
          column: ["date"],
          operator: "LESSER_THAN_EQUAL",
          value: to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }

      if (query) {
        finalUrl += "&" + query;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      onCallback(data);
    } catch (err: any) {
      onCallback([]);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
/*Insurance Remittance*/

export const FETCH_INSURANCE_REMMITTANCE_LIST_PROGRESS =
  "FETCH_INSURANCE_REMMITTANCE_LIST_PROGRESS";
export const FETCH_INSURANCE_REMMITTANCE_LIST_SUCCESS =
  "FETCH_INSURANCE_REMMITTANCE_LIST_SUCCESS";
export const FETCH_INSURANCE_REMMITTANCE_LIST_FAILURE =
  "FETCH_INSURANCE_REMMITTANCE_LIST_FAILURE";

export const fetchInsuranceRemittanceListProgress = () =>
  action(FETCH_INSURANCE_REMMITTANCE_LIST_PROGRESS);
export const fetchInsuranceRemittanceListSuccess = (
  list: IInsuranceRemittance[]
) => action(FETCH_INSURANCE_REMMITTANCE_LIST_SUCCESS, { list });
export const fetchInsuranceRemittanceListFailure = () =>
  action(FETCH_INSURANCE_REMMITTANCE_LIST_FAILURE);

export const fetchInsuranceRemittanceListAsync =
  (searchState: {
    [key: string]: any;
  }): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchInsuranceRemittanceListProgress());

      const {
        insurer_code,
        from_date,
        to_date,
        policy_number,
        name,
        branch_code,
        user_code,
      } = searchState;

      let finalUrl = `/accounting/get-remittance-list-by-insurance-company?from_date=${from_date}&to_date=${to_date}`;

      if (insurer_code) {
        finalUrl += `&insurer_code=${insurer_code}`;
      }

      if (policy_number) {
        finalUrl += `&policy_number=${policy_number}`;
      }

      if (name) {
        finalUrl += `&name=${name}`;
      }

      if (branch_code) {
        finalUrl += `&branch_code=${branch_code}`;
      }

      if (user_code) {
        finalUrl += `&producer_one_code=${user_code}`;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      dispatch(fetchInsuranceRemittanceListSuccess(data));
    } catch (err: any) {
      dispatch(fetchInsuranceRemittanceListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const downloadInsurerRemittancePayable =
  (searchState: {
    [key: string]: any;
  }): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const {
        from_date,
        to_date,
        name,
        policy_number,
        insurer_code,
        branch_code,
        user_code,
      } = searchState;
      dispatch(saveLoaderProgress());

     let finalUrl = `/accounting/get-remittance-list-by-insurance-company-pdf?`;
const params = [];

if (from_date) params.push(`from_date=${encodeURIComponent(from_date)}`);
if (to_date) params.push(`to_date=${encodeURIComponent(to_date)}`);
if (name) params.push(`name=${encodeURIComponent(name)}`);
if (policy_number) params.push(`policy_number=${encodeURIComponent(policy_number)}`);
if (insurer_code) params.push(`insurer_code=${encodeURIComponent(insurer_code)}`);
if (branch_code) params.push(`branch_code=${encodeURIComponent(branch_code)}`);
if (user_code) params.push(`producer_one_code=${encodeURIComponent(user_code)}`);

finalUrl += params.join("&");

      const res = await api.get(finalUrl, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([res.data], {
        type:
          "application/" + getFileExtensionFromUrl("Remittance-List.pdf"),
      });
      // const blob = new Blob([res.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      // Create a link element and simulate a click to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Remittance-List.pdf"); // Set the desired file name and extension
      document.body.appendChild(link);
      link.click();
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_AGED_INSURER_PAYABLES_LIST_PROGRESS =
  "FETCH_AGED_INSURER_PAYABLES_LIST_PROGRESS";
export const FETCH_AGED_INSURER_PAYABLES_LIST_SUCCESS =
  "FETCH_AGED_INSURER_PAYABLES_LIST_SUCCESS";
export const FETCH_AGED_INSURER_PAYABLES_LIST_FAILURE =
  "FETCH_AGED_INSURER_PAYABLES_LIST_FAILURE";

export const fetchAgedInsurerPayablesListProgress = () =>
  action(FETCH_AGED_INSURER_PAYABLES_LIST_PROGRESS);
export const fetchAgedInsurerPayablesListSuccess = (
  list: IAgedInsurerPayables[]
) => action(FETCH_AGED_INSURER_PAYABLES_LIST_SUCCESS, { list });
export const fetchAgedInsurerPayablesListFailure = () =>
  action(FETCH_AGED_INSURER_PAYABLES_LIST_FAILURE);

export const fetchAgedInsurerPayablesListAsync =
  (searchState: {
    [key: string]: any;
  }): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAgedInsurerPayablesListProgress());

      const { to_date } = searchState;

      let finalUrl = `/accounting/get-aged-company-payable`;

      if (to_date) {
        finalUrl += `?to_date=${to_date}`;
      }

      const res = await api.get(finalUrl);
      const data = res.data.data;
      dispatch(fetchAgedInsurerPayablesListSuccess(data));
    } catch (err: any) {
      dispatch(fetchAgedInsurerPayablesListFailure());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const downloadAgedInsurerPayable =
  (date: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      const finalUrl = `/accounting/get-aged-company-payable-pdf?to_date=${date}`;

      const res = await api.get(finalUrl, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([res.data], {
        type:
          "application/" + getFileExtensionFromUrl("Aged_Insurer_Payable.pdf"),
      });
      // const blob = new Blob([res.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      // Create a link element and simulate a click to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Aged_Insurer_Payable.pdf"); // Set the desired file name and extension
      document.body.appendChild(link);
      link.click();
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
/**-------- */

export const CLEAR_SALES_SUMMARY_STATE = "CLEAR_SALES_SUMMARY_STATE";
export const clearSalesSummaryState = () => action(CLEAR_SALES_SUMMARY_STATE);
